import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import styles from './style.scss';
import { pluralize, formatNumber } from 'utils';
import { addToFavorites, removeFromFavorites } from 'actions/favorites';
import { setPopUp } from 'actions/environment';

import { ROOT_URL } from 'constants/Config.js';

import CollectionsDialog from 'components/Building/Main/CollectionsDialog';

import ArrowLeft from 'assets/images/icons/carousel-arrow-left.svg';
import iconClose from 'assets/images/icons/icon-close.svg';
import iconHeart from 'assets/images/icons/icon-heart.svg';
import iconHeartActive from 'assets/images/icons/icon-heart-active-blue.svg';
import placeholder from 'assets/images/banner-placeholder.jpg';
import cn from 'classnames';
import tracker from '../../../../services/tracker';
import { withTranslation } from 'react-i18next';

let cx = cn.bind(styles);

const addDefaultSrc = (ev) => {
  ev.target.src = placeholder;
};

class PlaceInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bigImageLoaded: [],
      currentImageIndex: 0,
    };
  }

  handleBigImageLoad = (index) => {
    this.setState((prevState) => {
      const newBigImageLoaded = [...prevState.bigImageLoaded];
      newBigImageLoaded[index] = true;
      return { bigImageLoaded: newBigImageLoaded };
    });
  };

  prevImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState((prevState) => {
      const { albums } = this.props.point;
      if (!albums || albums.length === 0) return { currentImageIndex: 0 };

      return {
        currentImageIndex: (prevState.currentImageIndex - 1 + albums.length) % albums.length,
      };
    });
  };

  nextImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState((prevState) => {
      const { albums } = this.props.point;
      if (!albums || albums.length === 0) return { currentImageIndex: 0 };

      return {
        currentImageIndex: (prevState.currentImageIndex + 1) % albums.length,
      };
    });
  };

  handleAddToCollectionClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const { point, profile } = this.props;
    const { id: buildingId, title: buildingName } = point;

    tracker.sendEvent('Web_Add_To_Collection', {
      id: buildingId,
      name: buildingName,
      mode: 'map',
    });

    this.props.setPopUp(
      <CollectionsDialog
        building={{ data: this.props.point }}
        profile={profile}
        objectType={point.type_id === 1 ? 'zhk' : 'kp_i_th'}
      />,
      {
        // closeClassName: styles.popupClose,
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default',
        lockScroll: false,
      }
    );
  };

  handleAddToFavoritesClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { point } = this.props;
    const { id: buildingId, title: buildingName, favorite } = point;
    const userUid = localStorage.getItem('public');

    tracker.sendEvent(favorite ? 'Web_Remove_From_Favorites' : 'Web_Add_To_Favorites', {
      id: buildingId,
      name: buildingName,
      mode: 'map',
    });

    this.props[favorite ? 'removeFromFavorites' : 'addToFavorites'](
      { buildingId, userUid },
      { buildingName, data: this.props }
    );
  };

  handleClick = () => {
    const { point } = this.props;
    const { id: buildingId, title: buildingName } = point;

    tracker.sendEvent('Web_Click', {
      id: buildingId,
      name: buildingName,
      mode: 'map',
    });
  };

  render() {
    const { point, style, infoType } = this.props;
    const { bigImageLoaded, currentImageIndex } = this.state;

    if (!point) {
      return (
        <div style={style} className={styles.PlaceInfo}>
          <div className={styles.Loader} />
        </div>
      );
    }

    const { onClose, t } = this.props;

    const {
      title,
      address,
      albums,
      microregion,
      favorite,
      image,
      count_flats: flatsCount,
      cost_min: costMin,
      min_area_cost: minAreaCost,
      min_square: minSquare,
      max_square: maxSquare,
      construction_ending,
      construction_finished,
      year_built,
      status,
      view_action,
      type_id,
      country,
    } = point;

    const hasMultipleImages = albums && albums.length > 1;
    const currentImage = albums.length ? albums[currentImageIndex] : null;
    const isBigImageLoaded = bigImageLoaded[currentImageIndex];

    const currency = country.country_currency_symbol;

    return (
      <a
        style={style}
        onClick={this.handleClick}
        className={cx(styles.PlaceInfo, infoType === 'medium' ? styles.Medium : null)}
        href={
          infoType !== 'medium'
            ? `/building/${point.id}`
            : `/view/${location.href.replace(/.*\//, '')}/building/${point.id}`
        }
        target="_blank"
      >
        <div className={cn(styles.Header, { [styles.WithoutPhoto]: !image })}>
          <div className={styles.ImageWrapper}>
            {hasMultipleImages && (
              <button className={styles.PrevButton} onClick={this.prevImage}>
                <img src={ArrowLeft} alt="Previous" />
              </button>
            )}

            {currentImage ? (
              <Fragment key={currentImage ? currentImage.id : 'placeholder'}>
                <img
                  src={`${ROOT_URL}/image?id=${currentImage.id}&size=small`}
                  alt="house"
                  className={cn(styles.SmallImage, {
                    [styles.SmallImageHidden]: isBigImageLoaded,
                  })}
                  onLoad={() => this.handleSmallImageLoad(currentImageIndex)}
                  onError={addDefaultSrc}
                />
                <img
                  src={`${ROOT_URL}/image?id=${currentImage.id}&size=original`}
                  alt="house"
                  className={cn(styles.BigImage, {
                    [styles.BigImageVisible]: isBigImageLoaded,
                  })}
                  onLoad={() => this.handleBigImageLoad(currentImageIndex)}
                  onError={addDefaultSrc}
                />
              </Fragment>
            ) : (
              <img
                src={image ? `${ROOT_URL}/image?id=${image.name}&size=original` : placeholder}
                alt="placeholder"
                className={styles.WithoutPhoto}
              />
            )}

            {hasMultipleImages && (
              <button className={styles.NextButton} onClick={this.nextImage}>
                <img src={ArrowLeft} alt="Next" style={{ transform: 'rotate(180deg)' }} />
              </button>
            )}
          </div>
          <div>
            <h1>{title}</h1>
            <h3 className={styles.Address}>{`${microregion}, ${address}`}</h3>
            <div>
              {view_action ? (
                <span className={styles.PromoLabel}>{t('components.common.yPlaceInfo.promo')}</span>
              ) : null}
              {status == 3 ? (
                <span className={styles.AlmostFinished}>
                  {t('components.common.yPlaceInfo.almostFinished')}
                </span>
              ) : (
                <span
                  className={construction_finished ? styles.StatusTitle : styles.StatusTitleNotFin}
                >
                  {construction_finished
                    ? t('components.common.yPlaceInfo.finished')
                    : year_built !== 0
                    ? ` ${construction_ending} / ${year_built !== '0' ? year_built : ''}`
                    : t('components.common.yPlaceInfo.inProgress')}
                </span>
              )}
            </div>
          </div>
          <img src={iconClose} alt="" onClick={onClose} className={styles.IconButton} />
        </div>
        {flatsCount ? (
          <div className={styles.Flats}>
            {status === 2 ? (
              <div className={styles.Stopped}>{t('components.common.yPlaceInfo.promo')}</div>
            ) : (
              <div>
                {infoType == 'medium' ? (
                  <div className={styles.FlatsCount}>
                    <p>
                      {' '}
                      {flatsCount}{' '}
                      {pluralize(
                        flatsCount,
                        t('components.common.yPlaceInfo.flat1'),
                        t('components.common.yPlaceInfo.flat2'),
                        t('components.common.yPlaceInfo.flat3')
                      )}
                    </p>
                  </div>
                ) : (
                  <div>
                    <p>
                      {' '}
                      {flatsCount}{' '}
                      {pluralize(
                        flatsCount,
                        t('components.common.yPlaceInfo.flat1'),
                        t('components.common.yPlaceInfo.flat2'),
                        t('components.common.yPlaceInfo.flat3')
                      )}
                    </p>
                    <p> {t('components.common.yPlaceInfo.square', { minSquare, maxSquare })}</p>
                  </div>
                )}
              </div>
            )}
            {infoType == 'medium' ? (
              <div className={styles.FlatsPrices}>
                <p>
                  {`${t('components.common.yPlaceInfo.costMin', {
                    costMin: formatNumber(costMin),
                    currency,
                  })}, ${t('components.common.yPlaceInfo.minAreaCost', {
                    minAreaCost: formatNumber(minAreaCost),
                    currency,
                  })}`}
                </p>
              </div>
            ) : (
              <div>
                <p>
                  {t('components.common.yPlaceInfo.costMin', {
                    costMin: formatNumber(costMin),
                    currency,
                  })}
                </p>
                <p>
                  {t('components.common.yPlaceInfo.minAreaCost', {
                    minAreaCost: formatNumber(minAreaCost),
                    currency,
                  })}
                </p>
              </div>
            )}
          </div>
        ) : (
          <div className={cn(styles.Flats, styles.SoldOut)}>
            {status === 2
              ? t('components.common.yPlaceInfo.stopped')
              : type_id == 2
              ? t('components.common.yPlaceInfo.soldHouses')
              : t('components.common.yPlaceInfo.soldFlats')}
          </div>
        )}
        {infoType !== 'medium' && (
          <div className={styles.Buttons}>
            <div
              className={cn(styles.Button, styles.Favorites)}
              onClick={this.handleAddToFavoritesClick}
            >
              <img src={favorite ? iconHeartActive : iconHeart} alt="" />
              {favorite
                ? t('components.common.yPlaceInfo.inFavorite')
                : t('components.common.yPlaceInfo.addToFavorite')}
            </div>
            <div
              className={cn(styles.Button, styles.Collections)}
              onClick={this.handleAddToCollectionClick}
            >
              <span className={styles.iconPlus}>
                <i></i>
                <i></i>
              </span>
              {t('components.common.yPlaceInfo.addToCollection')}
            </div>
          </div>
        )}
      </a>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps, { setPopUp, addToFavorites, removeFromFavorites })(
  withTranslation()(PlaceInfo)
);



// WEBPACK FOOTER //
// ./src/components/common/YMap/YPlaceInfo/index.js